
const toolJS = {};

toolJS.getfontColor = function (backgroundColor) {
    if (this.colorDiff(backgroundColor, '000000') < this.colorDiff(backgroundColor, 'ffffff')) {
        return 'ffffff';
    }
    return '000000';
};

toolJS.colorDiff = function (c1, c2) {
    var c11 = parseInt(c1.substring(0, 2), 16);
    var c12 = parseInt(c1.substring(2, 4), 16);
    var c13 = parseInt(c1.substring(4, 6), 16);
    var c21 = parseInt(c2.substring(0, 2), 16);
    var c22 = parseInt(c2.substring(2, 4), 16);
    var c23 = parseInt(c2.substring(4, 6), 16);
    return Math.abs(c11 - c21) + Math.abs(c12 - c22) + Math.abs(c13 - c23);
};

export default toolJS;